import styled from 'styled-components';

import { pxToRem } from 'utils/scss';

export const RfidCardMainContainer = styled.div`
  border-radius: ${pxToRem('16px')};
  padding: ${pxToRem('24px')} ${pxToRem('30px')};
  margin: ${pxToRem('40px')} -${pxToRem('30px')} -${pxToRem('60px')} -${pxToRem('30px')};
`;

export const RfidHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${pxToRem('40px')};
`;
export const FiltersContainer = styled.div`
  width: ${pxToRem('406px')};
`;
